import { Currency, VbanDetails } from 'src/app/api/autogenerated';

export interface CurrencyOption {
  value: string;
  code: string;
  fullName: string;
  flag: string;
}

const CURRENCY_METADATA: Record<
  string,
  { code: string; fullName: string; flag: string }
> = {
  usd: {
    code: 'USD',
    fullName: 'United States Dollar',
    flag: '/assets/images/flag/currency/usd.svg',
  },
  gbp: {
    code: 'GBP',
    fullName: 'British Pound',
    flag: '/assets/images/flag/currency/gbp.svg',
  },
  cad: {
    code: 'CAD',
    fullName: 'Canadian Dollar',
    flag: '/assets/images/flag/currency/cad.svg',
  },
  aud: {
    code: 'AUD',
    fullName: 'Australian Dollar',
    flag: '/assets/images/flag/currency/aud.svg',
  },
  sgd: {
    code: 'SGD',
    fullName: 'Singapore Dollar',
    flag: '/assets/images/flag/currency/sgd.png',
  },
  eur: {
    code: 'EUR',
    fullName: 'Euro',
    flag: '/assets/images/flag/currency/euro.svg',
  },
  chf: {
    code: 'CHF',
    fullName: 'Swiss Franc',
    flag: '/assets/images/flag/currency/chf.svg',
  },
  try: {
    code: 'TRY',
    fullName: 'Turkish Lira',
    flag: '/assets/images/flag/currency/try.svg',
  },
  aed: {
    code: 'AED',
    fullName: 'United Arab Emirates Dirham',
    flag: '/assets/images/flag/currency/aed.svg',
  },
  cnf: {
    code: 'CNF',
    fullName: 'Chinese Yuan',
    flag: '/assets/images/flag/currency/cnf.svg',
  },
};

export function getCurrencyFlagPath(currencyCode: string): string {
  const key = currencyCode?.toLowerCase() ?? '';
  return CURRENCY_METADATA[key]?.flag ?? '/assets/images/flag/currency/usd.svg';
}

export function sortCurrencyOptionsByCode(
  options: CurrencyOption[],
): CurrencyOption[] {
  return [...options].sort((a, b) =>
    a.code.localeCompare(b.code, 'en', { sensitivity: 'base' }),
  );
}

function toCurrencyOption(currency: Currency): CurrencyOption {
  const value = currency.toLowerCase();
  const metadata = CURRENCY_METADATA[value];

  if (metadata) {
    return { value, ...metadata };
  }

  return {
    value,
    code: currency,
    fullName: currency,
    flag: '/assets/images/flag/currency/usd.svg',
  };
}

export function buildCurrencyOptionsFromVbanDetailsList(
  vbanDetailsList: VbanDetails[] | undefined,
): CurrencyOption[] {
  if (!vbanDetailsList?.length) {
    return [];
  }

  const seen = new Set<string>();
  const options: CurrencyOption[] = [];

  vbanDetailsList.forEach((vban) => {
    if (!vban.currency) {
      return;
    }
    const value = vban.currency.toLowerCase();
    if (seen.has(value)) {
      return;
    }
    seen.add(value);
    options.push(toCurrencyOption(vban.currency));
  });

  return sortCurrencyOptionsByCode(options);
}
